import { useEffect, useMemo } from "react";
import styles from "./HistoryItem.module.css";

import { useNavigate } from "react-router";
import { CurrencyFormat } from "../config/services";
import { Avatar, Card, CardContent, Typography } from "@mui/joy";
import { CallMade, CallReceived } from "@mui/icons-material";
import { doc } from "firebase/firestore";
import { db } from "../config/firebase";

export function convertTimestamp(timestamp) {
  let date = timestamp.toDate();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();
  let yyyy = date.getFullYear();

  date = mm + "-" + dd + "-" + yyyy;
  return date;
}

export function convertTimestampTime(timestamp) {
  let time = timestamp.toDate();
  let hours = time.getHours();
  let minutes = time.getMinutes();
  let ampm = hours >= 12 ? "pm" : "am";

  time = hours + ":" + minutes + " " + ampm;
  return time;
}

export function HistoryItem({ data, id, imageCode, frameBorder }) {
  
  const navigate = useNavigate();
  const frameStyle = useMemo(() => {
    return {
      border: frameBorder,
    };
  }, [frameBorder]);

  let {
    transaction_type,
    recipient,
    amount,
    timestamp,
    confirmation,
    cointitle,
  } = data;

  const referance = data.referance === "" ? "-" : data.referance;

  const isCredit = transaction_type === "Credit";
  const isPending = confirmation < 3;
  const isrecipient = isCredit ? "-" : recipient;
  const timestampset = `${convertTimestamp(timestamp)} ${convertTimestampTime(
    timestamp
  )}`;

  return (
    <div
      onClick={() => navigate(`/detail`, { state: { ...data, id: id } })}
      className={styles.frame}
    >
      <div className={styles.frame1}>
        <div className={styles.frameParent}>
          <div className={styles.frameWrapper}>
            <Avatar size="lg" variant="outlined">
              {isCredit ? <CallReceived /> : <CallMade />}
            </Avatar>
          </div>
          <img className={styles.frameIcon} alt="" src={imageCode} />
        </div>
        <div className={styles.frame3}>
          
          <div className={styles.frame5}>
            <Typography level="body-md">
              {isCredit ? "Receive" : "Sent"} •{" "}
              {convertTimestampTime(timestamp)}
            </Typography>
          </div>
        </div>
      </div>
      <div style={{ textAlign: "right" }}>
        <Typography level="title-sm" color={isPending ? "warning" : "success"}>
          {isPending ? "Pending" : "Confirmed"}
        </Typography>

        <Typography level="body-sm">
          {isCredit ? "+" : "-"}
          <CurrencyFormat amount={amount} prefix={"$"} seperator={true} />
        </Typography>
      </div>
    </div>
  );
}
